<div class="custom-table overflow-x-auto">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.PRODUCT_LIST.PRODUCT_NAME' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[35px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.PRODUCT_LIST.SKU_Num' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.PRODUCT_LIST.BRAND&CAT' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.PRODUCT_LIST.STOCK_AVAILABILITY' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.PRODUCT_LIST.PRICE' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.PRODUCT_LIST.GENDER' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.PRODUCT_LIST.CREATION_DATE' | translate }}
				</td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<ng-container
				*ngFor="
					let product of productsList
						| paginate
							: {
									itemsPerPage: productFilter?.paging?.pageSize,
									currentPage: productFilter?.paging?.pageNumber,
									totalItems: totalCount
							  };
					let indx = index
				"
			>
				<tr
					[ngClass]="{
						'border-b-[1px] border-secondry-color-Gray':
							indx + 1 != productsList?.length
					}"
					class="h-[68px]"
				>
					<td
						class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] ltr:pl-[12px] rtl:pr-[12px] ltr:pr-[36px] rtl:pl[36px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[240px]"
					>
						<span
							class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative {{
								product?.hasVariant ? '' : 'ltr:pl-[23px] rtl:pr-[23px] '
							}}"
						>
							<img
								*ngIf="expandedProductId !== product.id && product?.hasVariant"
								(click)="toggle(product)"
								src="assets/images/down-arrow.png"
								class="ltr:mr-2 rtl:ml-2"
								alt=""
							/>
							<img
								*ngIf="expandedProductId === product.id && product?.hasVariant"
								(click)="toggle(product)"
								src="assets/images/up-arrow.png"
								class="ltr:mr-2 rtl:ml-2"
								alt=""
							/>
							<img
								[src]="attachmentUrl + product?.mainImageUrl"
								class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
								alt=""
							/>
							<h1
								*ngIf="translate.currentLang == 'en'"
								class="text-font-16 text-dark-grey max-mobile:text-font-12 mb-0"
							>
								{{ product?.productName?.en | slice : 0 : 13 }}
								{{ product.productName.en.length > 13 ? '...' : '' }}
							</h1>
							<h1
								*ngIf="translate.currentLang == 'ar'"
								class="text-font-16 text-dark-grey max-mobile:text-font-12 mb-0"
							>
								{{ product?.productName?.ar | slice : 0 : 13 }}
								{{ product.productName.ar.length > 13 ? '...' : '' }}
							</h1>
						</span>
					</td>
					<td
						*ngIf="product?.skuNumber !== null"
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[35px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ product?.skuNumber | slice : 0 : 13 }}
						{{
							product?.skuNumber
								? product.skuNumber.length > 13
									? '...'
									: ''
								: ''
						}}
					</td>
					<td
						*ngIf="product?.skuNumber == null"
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[35px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						---
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{
							translate.currentLang == 'en'
								? product?.categoryName?.en
								: product?.categoryName?.ar
						}}
						<p class="text-font-14 text-medium-gray mb-0">
							{{
								translate.currentLang == 'en'
									? product?.brandName?.en
									: product?.brandName?.ar
							}}
						</p>
					</td>
					<td
						*ngIf="product?.stockCount != null && product?.stockCount != 0"
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[170px]"
					>
						{{ product?.stockCount }}
						<img
							*ngIf="product?.hasLowQuantity"
							class="inline-block"
							src="./assets/images/arrow_down_red.svg"
							alt=""
						/>
					</td>
					<td
						*ngIf="product?.stockCount == null && product?.stockCount != 0"
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[170px]"
					>
						---
					</td>
					<td
						*ngIf="product?.stockCount == 0"
						class="text-font-16 leading-[22px] text-[#B3261E] bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[170px]"
					>
						{{ 'STATUS.OUTOFSTOCK' | translate }}
					</td>
					<td
						*ngIf="product?.price != null"
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ product?.price }}
						<span *ngIf="productFilter?.countryId == 224">{{
							'CURRENCY.EGP' | translate
						}}</span>
						<span *ngIf="productFilter?.countryId == 103">{{
							'CURRENCY.SAR' | translate
						}}</span>

						<p
							*ngIf="
								product?.discountAmount != null && product?.isDiscountFixed
							"
							class="text-font-12 text-medium-gray mb-0"
						>
							{{ product.price - product.discountAmount }}
							<span *ngIf="productFilter?.countryId == 224">{{
								'CURRENCY.EGP' | translate
							}}</span>
							<span *ngIf="productFilter?.countryId == 103">{{
								'CURRENCY.SAR' | translate
							}}</span>
						</p>

						<p
							*ngIf="
								product?.discountAmount != null && !product?.isDiscountFixed
							"
							class="text-font-12 text-medium-gray mb-0"
						>
							{{ product?.discountAmount }} %
						</p>
					</td>

					<td
						*ngIf="product?.price == null"
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						---
					</td>
					<td>
						<span class="text-font-16" *ngIf="product?.gender?.includes(0)"
							>{{ 'GENERAL_LABELS.WOMEN' | translate }}
						</span>
						<span class="text-font-16" *ngIf="product?.gender?.includes(1)"
							>{{ 'GENERAL_LABELS.MEN' | translate }}
						</span>
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ product?.creationDate | date : 'dd/MM/yyyy' }}
						<p class="text-font-14 text-medium-gray mb-0">
							{{ product?.creationDate | date : 'hh:mm a' }}
						</p>
					</td>
					<td
						class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<span
							[routerLink]="['product-details', product.id]"
							class="inline-block max-mobile:w-[20px] w-[16px] text-end"
						>
							<img
								[src]="'assets/images/view.svg'"
								alt=""
								class="inline-block cursor-pointer"
							/>
						</span>
					</td>
				</tr>
				<!-- Sub-Products Section -->
				<ng-container
					*ngFor="
						let subProduct of product.productVariants;
						let subIndx = index
					"
				>
					<tr
						*ngIf="expandedProductId === product.id"
						[ngClass]="{
							'border-b-[1px] border-secondry-color-Gray':
								subIndx + 1 != productsList?.length
						}"
						class="relative h-[68px]"
					>
						<td
							[routerLink]="['product-details', product.id]"
							class="cursor-pointer text-font-14 leading-[20px] text-medium-gray bg-grey-background max-mobile:px-padding-mobile-12 whitespace-nowrap flex justify-center gap-[9px] items-center"
						>
							<div
								class="ltr:border-r-[1px] rtl:border-l-[1px] border-secondry-color-Gray bg-off-white w-[20px] h-[65px] {{
									subIndx + 1 != product.productVariants?.length ? 'bor' : ''
								}}"
							></div>
							<span
								class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative ltr:pl-[12px] rtl:pr-[12px]"
							>
								<img
									[src]="attachmentUrl + subProduct?.mainImageUrl"
									class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[36px] max-mobile:h-[36px] rounded-full mx-2"
									alt=""
								/>
								<h1
									*ngIf="translate.currentLang == 'en'"
									class="text-font-14 text-dark-grey max-mobile:text-font-12 mb-0"
								>
									{{ subProduct?.variantName?.en | slice : 0 : 13 }}
									{{ subProduct.variantName.en.length > 13 ? '...' : '' }}
								</h1>
								<h1
									*ngIf="translate.currentLang == 'ar'"
									class="text-font-14 text-dark-grey max-mobile:text-font-12 mb-0"
								>
									{{ subProduct?.variantName?.ar | slice : 0 : 13 }}
									{{ subProduct.variantName.ar.length > 13 ? '...' : '' }}
								</h1>
							</span>
							<span
								*ngIf="subProduct?.variantType?.id == 1"
								class="h-[24px] w-[24px] rounded-full"
								[style.backgroundColor]="subProduct?.variantTypeSettings || ''"
							>
							</span>
							<span
								*ngIf="subProduct?.variantType?.id == 2"
								class="text-font-14 text-dark-grey"
							>
								<p class="m-0">{{ subProduct?.variantTypeSettings }}</p>
							</span>
						</td>
						<td
							*ngIf="product?.skuNumber !== null"
							class="text-font-14 leading-[20px] text-dark-grey bg-grey-background py-[4px] px-[35px] max-mobile:px-padding-mobile-12 whitespace-nowrap"
						>
							{{ subProduct?.skuNumber | slice : 0 : 13 }}
							{{
								subProduct?.skuNumber
									? subProduct.skuNumber.length > 13
										? '...'
										: ''
									: ''
							}}
						</td>
						<td
							*ngIf="product?.skuNumber == null"
							class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[35px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
						>
							{{ subProduct?.skuNumber | slice : 0 : 13 }}
							{{
								subProduct?.skuNumber
									? subProduct.skuNumber.length > 13
										? '...'
										: ''
									: ''
							}}
						</td>
						<td
							class="text-font-14 leading-[20px] text-dark-grey bg-grey-background py-[4px] px-[10px] max-mobile:px-padding-mobile-12 whitespace-nowrap"
						>
							{{
								translate.currentLang == 'en'
									? product?.categoryName?.en
									: product?.categoryName?.ar
							}}
							<p class="text-font-12 text-medium-gray mb-0">
								{{
									translate.currentLang == 'en'
										? product?.brandName?.en
										: product?.brandName?.ar
								}}
							</p>
						</td>
						<td
							*ngIf="
								subProduct?.stockCount != null && subProduct?.stockCount != 0
							"
							class="text-font-14 leading-[20px] text-dark-grey bg-grey-background py-[4px] px-[10px] max-mobile:px-padding-mobile-12 whitespace-nowrap w-[150px]"
						>
							{{ subProduct?.stockCount }}
							<img
								*ngIf="subProduct?.hasLowQuantity"
								class="inline-block"
								src="./assets/images/arrow_down_red.svg"
								alt=""
							/>
						</td>
						<td
							*ngIf="
								subProduct?.stockCount == null && subProduct?.stockCount != 0
							"
							class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[170px]"
						>
							---
						</td>
						<td
							*ngIf="subProduct?.stockCount == 0"
							class="text-font-16 leading-[22px] text-[#B3261E] bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[170px]"
						>
							{{ 'STATUS.OUTOFSTOCK' | translate }}
						</td>
						<td
							*ngIf="subProduct?.price != null"
							class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
						>
							{{ subProduct?.price }}
							<span *ngIf="productFilter?.countryId == 224">{{
								'CURRENCY.EGP' | translate
							}}</span>
							<span *ngIf="productFilter?.countryId == 103">{{
								'CURRENCY.SAR' | translate
							}}</span>

							<p
								*ngIf="
									subProduct?.discountAmount != null &&
									subProduct?.isDiscountFixed
								"
								class="text-font-12 text-medium-gray mb-0"
							>
								{{ subProduct.price - subProduct.discountAmount }}
								<span *ngIf="productFilter?.countryId == 224">{{
									'CURRENCY.EGP' | translate
								}}</span>
								<span *ngIf="productFilter?.countryId == 103">{{
									'CURRENCY.SAR' | translate
								}}</span>
							</p>

							<p
								*ngIf="
									subProduct?.discountAmount != null &&
									!subProduct?.isDiscountFixed
								"
								class="text-font-12 text-medium-gray mb-0"
							>
								{{ subProduct?.discountAmount }} %
							</p>
						</td>

						<td
							*ngIf="subProduct?.price == null"
							class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
						>
							---
						</td>
						<td>
							<span
								class="text-font-16 text-dark-grey"
								*ngIf="product?.gender?.includes(0)"
								>{{ 'GENERAL_LABELS.WOMEN' | translate }}
							</span>
							<span
								class="text-font-16 text-dark-grey"
								*ngIf="product?.gender?.includes(1)"
								>{{ 'GENERAL_LABELS.MEN' | translate }}
							</span>
						</td>
						<td
							class="text-font-14 leading-[20px] text-dark-grey bg-grey-background py-[4px] px-[10px] max-mobile:px-padding-mobile-12 whitespace-nowrap"
						>
							{{ subProduct?.creationDate | date : 'dd/MM/yyyy' }}
							<p class="text-font-12 text-medium-gray mb-0">
								{{ subProduct?.creationDate | date : 'hh:mm a' }}
							</p>
						</td>
						<td
							class="text-font-14 leading-[20px] text-medium-gray bg-grey-background py-[4px] px-[10px] max-mobile:px-padding-mobile-12 whitespace-nowrap"
						>
							<span
								[routerLink]="['product-details', product?.id]"
								class="inline-block max-mobile:w-[20px] w-[16px] text-end"
							>
								<img
									[src]="'assets/images/view.svg'"
									alt=""
									class="inline-block cursor-pointer"
								/>
							</span>
						</td>
					</tr>
				</ng-container>
			</ng-container>
		</tbody>
	</table>
</div>
